module.exports = __webpack_public_path__ + "static/media/workingmemory-numbers-8.501c9b27.mp3";